import { motion } from 'framer-motion'

import { isProxyAvailable } from '../utils'

export const motionCustom = (Custom: any) => {
  return isProxyAvailable
    ? motion(Custom, { forwardMotionProps: true })
    : Custom
}
